(function () {
  'use strict';

  /** @ngInject */
  function checkDateInPeriod(moment) {
    return {
      restrict: 'A',
      require: ['ngModel', '^uib-datepicker-popup'],
      scope: false,
      link: function (scope, elm, attrs, ctrls) {
        var ngModelCtrl = ctrls[0];
        scope.$watch(function () {
          return ngModelCtrl.$modelValue;
        }, function (date) {
          var datepickerOptions = scope.$eval(attrs.datepickerOptions);
          if (moment(date).isValid()) {
            var hasMinDate = Boolean(datepickerOptions.minDate);
            if (hasMinDate && moment(date).isBefore(moment(datepickerOptions.minDate))) {
              ngModelCtrl.$setValidity('minDate', false);
            } else {
              ngModelCtrl.$setValidity('minDate', true);
            }

            var hasMaxDate = Boolean(datepickerOptions.maxDate);
            if (hasMaxDate && moment(date).isAfter(moment(datepickerOptions.maxDate))) {
              ngModelCtrl.$setValidity('maxDate', false);
            } else {
              ngModelCtrl.$setValidity('maxDate', true);
            }
          }
        });
      }
    };
  }

  angular.module('wml.portal.generic')
    .directive('checkDateInPeriod', checkDateInPeriod)
})();
